import React from 'react';
import PropTypes from 'prop-types';

const Background = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="315"
    height="286"
    viewBox="0 0 315 286"
    role="presentation"
  >
    <g fill="none" fillRule="evenodd">
      <path fill="currentColor" d="M311 171.938L200.736 30 0 188.114 36.754 286H283.94z" />
      <path fill="#F2F1F1" d="M315 141.938L204.736 0 4 158.114 40.754 256H287.94z" />
    </g>
  </svg>
);

Background.propTypes = {
  className: PropTypes.string
};

export default Background;
